//src/lib/opaue-config.ts

import { getOpaqueConfig, OpaqueID } from "@cloudflare/opaque-ts";

// OPAQUE protocol configuration using P-256 elliptic curve
// This must match the server's OPAQUE configuration

export const OPAQUE_CONFIG = getOpaqueConfig(OpaqueID.OPAQUE_P256);

// Server identity string - must match what the backend expects
export const SERVER_IDENTITY = 'six3ro-server';

